import { Component, OnInit } from '@angular/core';
import {BsModalRef, BsModalService} from "ngx-bootstrap/modal";
import {PermissionsService} from "../../services/permissions/permissions.service";

@Component({
  selector: 'app-checks-help-modal',
  templateUrl: './checks-help-modal.component.pug',
  styleUrls: ['./checks-help-modal.component.scss'],
  standalone: false
})
export class ChecksHelpModalComponent implements OnInit {


  constructor(
    private modalService: BsModalService,
    private permissions: PermissionsService,
  ) { }

  ngOnInit(): void {
  }

  closeModal(): void {
    this.modalService.hide()
  }
}
